export default {
  name: "Priya Kumaresan",
  feedback: `Hi,this is priyakumaresan. 
  I have recently attended five days mastry class in baking in salem cake craft studio.it was a fantastic experience!
  The instructor Ramya mam was knowledgeable,patient and gave clear explanation.
  If you're a beginner or have some baking experience this class was more recommendable.`
};
